import { useReactiveVar } from '@apollo/client'

import { labelCodeIdVar, spaceIdVar } from 'modulesCommon/store'
import { useGetMostViewedProjectsQuery } from 'modules/Feed/graphql/getMostViewedProjects.types'

const useGetMostViewedProjects = () => {
  const space_id = useReactiveVar(spaceIdVar)
  const label_id = useReactiveVar(labelCodeIdVar)

  const mostViewedProjectsQuery = useGetMostViewedProjectsQuery({
    variables: { input: {space_id, label_id} },
  })

  return {
    mostViewedProjects: mostViewedProjectsQuery?.data?.getCampaignViews || []
  }
}

export default useGetMostViewedProjects
